import Helper from '@/utils/helper'
import ColorScheme from '@/app/service/api/model/color-scheme'
import Layout from '@/app/service/api/model/layout'
import ScreenSetting from '@/app/service/api/model/screen-setting'
import { layouts } from '@/app/const/settings'
import State from '@/app/service/api/model/state'
import SoftwareSettings from '@/app/service/api/model/software-settings'
import VolumeSetting from '@/app/service/api/model/volume-setting'

class Face {
  constructor ({ colorScheme, layout, screenSetting, states, softwareSettings, volumeLevel, volumeLevelMedia, volumeLevelMediaMuted }) {
    if (!Helper.isDefined(colorScheme)) {
      throw new Error('Color scheme is undefined')
    }
    try {
      this.colorScheme = new ColorScheme(colorScheme)
    } catch (e) {
      throw new Error(`Error parse colorScheme [e = '${e.message}']`)
    }

    try {
      this.layout = new Layout(layout)
    } catch (e) {
      throw new Error(`Error parse layout [e = '${e.message}']`)
    }

    try {
      if (Helper.isDefined(screenSetting)) {
        this.screenSetting = new ScreenSetting(screenSetting)
      }
    } catch (e) {
      throw new Error(`Error parse screenSetting [e = '${e.message}']`)
    }

    try {
      this.states = Helper.isDefined(states) ? states.map(state => new State(state)) : []
    } catch (e) {
      throw new Error(`Error parse screenSetting [e = '${e.message}']`)
    }

    try {
      this.softwareSettings = Helper.isDefined(softwareSettings) ? new SoftwareSettings(softwareSettings) : null
    } catch (e) {
      throw new Error(`Error parse softwareSettings [e = '${e.message}']`)
    }

    if (this.colorScheme.getCode() === layouts.col2State && this.states.validByCol2State()) {
      throw new Error('Error configured states by code col2State')
    }

    this.volumeSetting = new VolumeSetting({ volumeLevel, volumeLevelMedia, volumeLevelMediaMuted })
  }

  getLayout () {
    return this.layout
  }

  getColorScheme () {
    return this.colorScheme
  }

  getScreenSetting () {
    return this.screenSetting
  }

  getStates () {
    return this.states
  }

  getSoftwareSettings () {
    return this.softwareSettings
  }

  getVolumeSetting () {
    return this.volumeSetting
  }
}

export default Face
